import { Card } from "@fanduel/og-fe-library";
import { NextSeo } from "next-seo";
import ErrorComponent from "@/components/empty/ErrorComponent";
import HorseRacingHeader from "@/components/horseRacing/header";
import RaceList from "@/components/horseRacing/raceList/RaceList";
import BasicTerms from "@/components/horseRacing/widgets/basicTerms";
import { RACING_CONSENSUS_PICKS_PAGE_VIEWED } from "@/constants/amplitude";
import { SEO } from "@/constants/seo";
import { TermsT } from "@/types/horseRacing";
import filterPicksByDataSource from "@/utils/consensusHorseRacing";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import useOnce from "@/utils/hooks/useOnce";
import useUpcomingRaces from "@/utils/hooks/useUpcomingRaces";
import styles from "./container.module.scss";

interface ConsensusPicksContainer {
  title: string;
  description: string;
  initialTerms: TermsT;
}

const Container = ({
  title,
  description,
  initialTerms,
}: ConsensusPicksContainer) => {
  const { races, isError, isLoading, fetchNextPage } = useUpcomingRaces();
  const consensusRaces = filterPicksByDataSource(races ?? []);
  const { logAmplitudeEvent } = useAmplitude();

  useOnce(() => {
    logAmplitudeEvent(RACING_CONSENSUS_PICKS_PAGE_VIEWED, {});
  });
  return (
    <div className={styles.container}>
      <NextSeo
        title={title}
        description={description}
        canonical={SEO.CONSENSUS_PICKS_URL}
      />
      <HorseRacingHeader title={title} />
      <div className={styles.contentContainer}>
        {consensusRaces && consensusRaces.length > 0 ? (
          <RaceList
            isConsensus
            races={consensusRaces}
            loading={isLoading}
            fetchNextPage={fetchNextPage}
          />
        ) : (
          <Card
            variant="elevation"
            elevation="mid"
            className={styles.errorContainer}
          >
            <ErrorComponent
              headline={
                isError ? "Content failed to load" : "No projections available"
              }
              subtext={
                isError ? (
                  <div>
                    <p>No Projections available.</p>
                    <p>Please check back later.</p>
                  </div>
                ) : (
                  "Please check back later."
                )
              }
              showCta={isError}
            />
          </Card>
        )}

        <div className={styles.widgetContainer}>
          <BasicTerms initialTerms={initialTerms} />
        </div>
      </div>
    </div>
  );
};

export default Container;
